import React, { useMemo } from "react";

export default (props) => {
  return (
    <div>
      {props.data.product && props.data.product.prodBean
        ? props.data.product.prodBean.name
        : ""}
    </div>
  );
};
